/**
 * @generated SignedSource<<24a3aa80e1d80e12d181e0e34d597c41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HasForm = "HAS_FORM" | "NO_FORM" | "%future added value";
export type ImportAction = "CREATE" | "UPDATE" | "%future added value";
export type QueryMatch = "EQUAL_MATCH" | "INCLUDING_MATCH" | "PREFIX_MATCH" | "%future added value";
export type UrlMatch = "EQUAL_TYPE" | "HAS_ID_TYPE" | "EQUAL_OR_HAS_ID_TYPE" | "STARTS_WITH_PREFIX_MATCH" | "REGEX_MATCH_TYPE" | "%future added value";
export type ImportFunnelsInput = {
  clientMutationId?: string | null;
  siteId: string;
  funnels: ReadonlyArray<FunnelImportRowInput>;
};
export type FunnelImportRowInput = {
  action: ImportAction;
  funnelId?: string | null;
  name: string;
  isExperiment?: boolean | null;
  landingPage: FunnelImportPageInput;
  formPages?: ReadonlyArray<FunnelImportPageInput> | null;
  confirmPage?: FunnelImportPageInput | null;
  thanksPage: FunnelImportPageInput;
};
export type FunnelImportPageInput = {
  url: string;
  mobileUrl?: string | null;
  tabletUrl?: string | null;
  queryMatchType?: QueryMatch | null;
  urlMatchType: UrlMatch;
  hasForm?: HasForm | null;
  isEnableWhiteout?: boolean | null;
  isSpa?: boolean | null;
};
export type FunnelImportContainer_Mutation$variables = {
  input: ImportFunnelsInput;
};
export type FunnelImportContainer_MutationVariables = FunnelImportContainer_Mutation$variables;
export type FunnelImportContainer_Mutation$data = {
  readonly importFunnels: {
    readonly results: ReadonlyArray<{
      readonly rowIndex: number;
      readonly success: boolean;
      readonly errors: ReadonlyArray<{
        readonly field: string;
        readonly message: string;
      }>;
      readonly funnel: {
        readonly id: string;
        readonly slug: string;
        readonly name: string;
      } | null;
    }>;
  } | null;
};
export type FunnelImportContainer_MutationResponse = FunnelImportContainer_Mutation$data;
export type FunnelImportContainer_Mutation = {
  variables: FunnelImportContainer_MutationVariables;
  response: FunnelImportContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportFunnelsPayload",
    "kind": "LinkedField",
    "name": "importFunnels",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FunnelImportResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowIndex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImportError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Funnel",
            "kind": "LinkedField",
            "name": "funnel",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelImportContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelImportContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c34115b33121214de8dcc02db10efc7",
    "id": null,
    "metadata": {},
    "name": "FunnelImportContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation FunnelImportContainer_Mutation(\n  $input: ImportFunnelsInput!\n) {\n  importFunnels(input: $input) {\n    results {\n      rowIndex\n      success\n      errors {\n        field\n        message\n      }\n      funnel {\n        id\n        slug\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "63a2f1600c99e81ab7b66dc394a9a100";

export default node;
